var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsGenericError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#88wonzl8da)",
    fill: "#E8281E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10v13.333h5V10h-5zM20 30.833a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 .833C9.415.833.833 9.415.833 20S9.415 39.167 20 39.167c10.586 0 19.167-8.582 19.167-19.167S30.586.833 20 .833zM5.834 20c0-7.824 6.342-14.167 14.166-14.167 7.824 0 14.167 6.343 14.167 14.167S27.824 34.167 20 34.167 5.834 27.824 5.834 20z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "88wonzl8da"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGenericError);
export default __webpack_public_path__ + "static/media/icons-generic-error.cc75565bad0189eaaa908386d143ad82.svg";
export { ForwardRef as ReactComponent };